import React, { useState } from "react";
import { MainModal } from "../../../../components/modal/MainModal";
import { Input } from "../../../../components/Input.js/Input";
import { useDispatch } from "react-redux";
import { createPermissionGroup, resetStatus } from "../redux/usersSagas";
import { ErrorList } from "./ErrorList";
import { useError } from "../hooks/useError";
import { showToast } from "../../../../utils/showToast";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

export const CreateCustomPermissionGroup = ({ isOpen, onClose, selected: { id } }) => {
  const dispatch = useDispatch();

  const [roleName, setRoleName] = useState("");

  const { errors, status } = useError(() => {
    showToast("Role was created");
    onClose();
    dispatch(resetStatus());
  });

  const onSave = async () => {
    dispatch(createPermissionGroup({ id, name: roleName }));
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        onClose={onClose}
        parentSelector=".users"
        headerText="Save This Permission Group"
        headerCloseHandler={onClose}
        bodyClassName="main-popup-body"
        primaryButtonText="Save"
        primaryButtonClass="primary"
        primaryButtonDisabled={!roleName && status !== "pending"}
        primaryBtnHandler={onSave}
        secondaryBtnText="Cancel"
        secondaryBtnClass="secondary"
        secondaryBtnHandler={onClose}
        height="auto"
        width={600}
        isAdminPanel={false}
      >
        <p>
          You can save this permission group for future use and you will be able to use these
          permissions for any new users added to the system.
        </p>
        <Input
          value={roleName}
          onChange={setRoleName}
          label="Group Name (for example, manager, front desk, headquarters"
          htmlFor="roleName"
        />
        {status === "pending" && <LoadingAnimation uiLoader />}

        <ErrorList errors={errors} />
      </MainModal>
    </>
  );
};
